import { type Placement } from '@floating-ui/react';

import { type FloatingPlacement } from './Floating.types';

export const FLOATING_ARROW_WIDTH = 8; // px
export const FLOATING_ARROW_HEIGHT = 4; // px
export const FLOATING_ARROW_TIP_RADIUS = 3; // px
export const FLOATING_MINIMUM_REST_DELAY = 150; // ms
export const FLOATING_DEFAULT_TRANSITION_DURATION = 150; // ms
export const FLOATING_PLACEMENT_MAP: Record<FloatingPlacement, Placement> = {
    topLeft: 'top-start',
    top: 'top',
    topRight: 'top-end',
    rightTop: 'right-start',
    right: 'right',
    rightBottom: 'right-end',
    bottomLeft: 'bottom-start',
    bottom: 'bottom',
    bottomRight: 'bottom-end',
    leftTop: 'left-start',
    left: 'left',
    leftBottom: 'left-end'
};
export const FLOATING_TRIGGER_PROPS = [
    'data-state',
    'aria-describedby',
    'onKeyDown',
    'onMouseMove',
    'onPointerDown',
    'onPointerEnter',
    'onClick',
    'onKeyUp',
    'onMouseDown',
    'onBlur',
    'onContextMenu',
    'onFocus',
    'onMouseEnter',
    'onMouseLeave',
    'onTouchStart'
] as const;
